// FistOS control protocol — shared primitive types.
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
/**
 * Describes the file common.proto.
 */
export const file_common = /*@__PURE__*/ fileDesc("Cgxjb21tb24ucHJvdG8SCWZpc3Rvcy52MSJtCghLZXlWYWx1ZRILCgNrZXkYASABKAkSDQoDc3RyGAIgASgJSAASDQoDaW50GAMgASgDSAASDgoEcmVhbBgEIAEoAUgAEg4KBGZsYWcYBSABKAhIABINCgNyYXcYBiABKAxIAEIHCgV2YWx1ZSJACgRSZWN0EgwKBGxlZnQYASABKAUSCwoDdG9wGAIgASgFEg0KBXJpZ2h0GAMgASgFEg4KBmJvdHRvbRgEIAEoBSo7CgtJbWFnZUZvcm1hdBIVChFJTUFHRV9GT1JNQVRfSlBFRxAAEhUKEUlNQUdFX0ZPUk1BVF9XRUJQEAFiBnByb3RvMw");
/**
 * Describes the message fistos.v1.KeyValue.
 * Use `create(KeyValueSchema)` to create a new message.
 */
export const KeyValueSchema = /*@__PURE__*/ messageDesc(file_common, 0);
/**
 * Describes the message fistos.v1.Rect.
 * Use `create(RectSchema)` to create a new message.
 */
export const RectSchema = /*@__PURE__*/ messageDesc(file_common, 1);
/**
 * @generated from enum fistos.v1.ImageFormat
 */
export var ImageFormat;
(function (ImageFormat) {
    /**
     * @generated from enum value: IMAGE_FORMAT_JPEG = 0;
     */
    ImageFormat[ImageFormat["JPEG"] = 0] = "JPEG";
    /**
     * @generated from enum value: IMAGE_FORMAT_WEBP = 1;
     */
    ImageFormat[ImageFormat["WEBP"] = 1] = "WEBP";
})(ImageFormat || (ImageFormat = {}));
/**
 * Describes the enum fistos.v1.ImageFormat.
 */
export const ImageFormatSchema = /*@__PURE__*/ enumDesc(file_common, 0);
